"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = void 0;
const GetOrderList_1 = require("./GetOrderList");
const GetOrderDetails_1 = require("./GetOrderDetails");
const GetOrderAddInfo_1 = require("./GetOrderAddInfo");
const PostOrderAdd_1 = require("./PostOrderAdd");
__exportStar(require("./GetOrderList"), exports);
__exportStar(require("./GetOrderDetails"), exports);
__exportStar(require("./GetOrderAddInfo"), exports);
__exportStar(require("./PostOrderAdd"), exports);
exports.Order = {
    GetOrderList: GetOrderList_1.GetOrderList,
    GetOrderDetails: GetOrderDetails_1.GetOrderDetails,
    GetOrderAddInfo: GetOrderAddInfo_1.GetOrderAddInfo,
    PostOrderAdd: PostOrderAdd_1.PostOrderAdd
};
//# sourceMappingURL=index.js.map